<template>
  <v-card flat>
    <v-icon class="close" @click="closeClick">$sl-close</v-icon>
    <h2>{{$t('ebook.element-change')}}</h2>
    <v-select
      v-model="elementId"
      :items="elements"
      item-text="name"
      item-value="elementId"
      :label="$t('ebook.element')"
      @change="subElementId=0"
      outlined
    ></v-select>

    <v-select
      v-model="subElementId"
      :items="elementparts"
      item-text="name"
      item-value="id"
      :label="$t('ebook.elementpart')"
      outlined
    ></v-select>
    <div class="d-flex justify-space-between mt-6">
      <ActionButton
        :block="false"
        type="application"
        actionIcon="$sl-cancel"
        @click="closeClick"
      >{{ $t('labels.cancel') }}</ActionButton>
      <ActionButton
        :block="false"
        @click="saveClick"
        :isDisabled="subElementId < 1"
        actionIcon="$sl-hammer"
      >{{$t('labels.change2')}}</ActionButton>
    </div>
  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import find from 'lodash/find'
import ActionButton from '@/components/Common/ActionButton'

// @group Company
// EbookElementModalChangeElement component
export default {
  name: 'EbookElementModalChangeElement',

  components: {
    ActionButton
  },
  props: {
    //has raport detail
    reportDetail: Object,
    //has elements
    elements: Array
  },

  data: () => ({
    elementId: 0,
    subElementId: 0
  }),

  created() {
    this.init()
  },

  computed: {
    elementparts() {
      let elements = this.elements.find(x => x.elementId == this.elementId)
      if (!elements) return

      return elements.bookSubElements
    }
  },

  methods: {
    init() {
      if (this.reportDetail && this.reportDetail.subElement.element.elementId) {
        this.elementId = this.reportDetail.subElement.element.elementId
      }
      if (this.reportDetail && this.reportDetail.subElementId) {
        this.subElementId = this.reportDetail.subElementId
      }
    },
    /**
     * @vuese
     * Used to close modal and call init function
     */
    closeClick() {
      this.init()
      // Fire close event
      // @arg The argument is a string
      this.$emit('close')
    },
    /**
     * @vuese
     * Used to update the report detail
     * @arg The arguments are integers representing book id , report id,report detail id
     */
    saveClick() {
      if (
        this.$route.params.bookId &&
        this.$route.params.bookId > 0 &&
        this.reportDetail.id &&
        this.reportDetail.id > 0 &&
        this.subElementId &&
        this.subElementId > 0
      ) {
        let params = {
          subElementId: this.subElementId
        }

        API.updateReportDetail(this.$route.params.bookId, this.reportDetail.reportId, this.reportDetail.id, {
          data: params
        })
          .then(response => {
            this.$events.fire('showInfo', this.$t('success.saved'))
            // Fire updatedElement
            // @arg The argument is a string
            this.$emit('updatedElement')
          })
          .catch(error => {
            console.log('Error: ' + error)
            this.$events.fire('showError', this.$t('errors.save-failure'))
          })
      } else {
        this.$events.fire('showError', this.$t('errors.save-failure'))
      }
    }
  }
}
</script>